import { services } from '../../../constants/services';
import { getAll } from '../../../utils/api';

export const GetHoursBlockWithPaginationService = async (params: string = '') => {
  const response = await getAll<any>(`${services.qr}/hoursBlock?page=1&perPage=100&search=${params}`);
  return response;
};